import React from "react";

import styled from "styled-components";

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

export default function CalculationFomulaModal(props) {
  const { 
    isView,
    denominator,
    denominatorText,
    numerator,
    numeratorText,
    result,
    resultUnit,
    innerBoxBackgroundColor,
    componentBoxBackgroundColor,
    accentColor,
    top,
    left
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TopLevelWrapper isView={isView} top={top} left={left}>
      <Triangle backgroundColor={componentBoxBackgroundColor}/>
      <ComponentBox backgroundColor={componentBoxBackgroundColor}>
        <CalcInfoBox backgroundColor={innerBoxBackgroundColor}>
          <ColumnWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.text} cursor='default'>{denominator}</Text>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{denominatorText}</Text>
          </ColumnWrapper>
          <DivisionLine />
          <ColumnWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.text} cursor='default'>{numerator}</Text>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{numeratorText}</Text>
          </ColumnWrapper>
        </CalcInfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={20} color={theme.text} cursor='default'>X</Text>
        <Text style={{ marginTop: '-4px' }} fontFamily='NotoSansKR-Bold' fontSize={30} color={theme.text} cursor='default'>100</Text>
        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.text} cursor='default'>=</Text>
        <ResultWrapper>
          <Text style={{ marginTop: '-4px' }} fontFamily='NotoSansKR-Bold' fontSize={30} color={accentColor || theme.text} cursor='default'>{result}</Text>
          <Text style={{ marginTop: '12px' }} fontFamily='NotoSansKR-Bold' fontSize={10} color={accentColor || theme.text} cursor='default'>{resultUnit}</Text>
        </ResultWrapper>
      </ComponentBox>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: ${props => props.top != null ? props.top : 170}px;
  margin-left: ${props => props.left != null ? props.left : 54}px;

  opacity: ${props => props.isView ? 1 : 0};
  pointer-events: ${props => props.isView ? 'auto' : 'none'};

  transition: all 0.3s ease-in-out;
`;

const Triangle = styled.div`
  margin-left: 10px;

  width: 0;
  height: 0;

  border-bottom: 7px solid ${props => props.backgroundColor};
  border-right: 11px solid transparent; 
`;

const ComponentBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 10px;

  gap: 6px;

  border-radius: 10px;
  background-color: ${props => props.backgroundColor};
`;

const CalcInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px;

  border-radius: 10px;
  background-color: ${props => props.backgroundColor};
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const DivisionLine = styled.div`
  margin: 2px 0px;

  width: 100%;
  height: 1px;

  border-radius: 2px;
  background-color: ${props => props.theme.text};
`;

const ResultWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 2px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;